import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'
import { AvailableLanguages } from '@repo/toolkit/language-types'
import { StringFormatter } from '@repo/toolkit/string'
import Badge from '@repo/ui/badge'
import { Column } from '@repo/ui/data-table'
import { TFunction } from 'i18next'

import { genderOneLetterMapping } from '../../../../../lib/types/enums/common/gender.enum'
import { teflTypeEnumMapping } from '../../../../../lib/types/enums/ol/tefl-type.enum'
import { CenterTefl } from '../../../../../lib/types/models/center-tefl/center-tefl'

export const centerTeflColumns = (
  t: TFunction<AvailableLanguages, undefined>,
  enableSorting: boolean = true
): Column<CenterTefl>[] => [
  {
    enableSorting,
    accessorFn: (row) => row.tefl?.firstName,
    accessorKey: 'tefl.firstName',
    header: t('ol.center.tefl.table.firstName'),
    cell: ({ row }) =>
      valueRender(row.original.tefl?.firstName, (firstName) =>
        StringFormatter.capitalize(firstName)
      )
  },
  {
    enableSorting,
    accessorKey: 'qualification',
    header: t('ol.center.tefl.table.qualification'),
    cell: ({ row }) =>
      row.original.qualification ? (
        <Badge variant="white" text={t(teflTypeEnumMapping[row.original.qualification])} />
      ) : (
        '-'
      )
  },
  {
    enableSorting,
    accessorKey: 'tefl.birthDate',
    header: t('ol.center.tefl.table.age'),
    cell: ({ row }) =>
      valueRender(row.original.tefl?.birthDate, (date) =>
        DateFormatter.calculateAge(date).toString()
      )
  },
  {
    enableSorting,
    accessorKey: 'tefl.gender',
    header: t('ol.center.tefl.table.gender'),
    cell: ({ row }) =>
      valueRender(row.original.tefl?.gender, (gender) => genderOneLetterMapping[gender].label)
  }
]
